export default {
	SET_DATA(state, payload) {
		state.choiceMitra = payload.data
		state.numChoiceMitra = payload.recordsTotal
	}
}